<template>
  <div>
    <!-- <div
      v-if="fetching === true"
      v-loading="true"
      style="height: 500px;"
    /> -->
    <div
      class="notice-table-box"
    >
      <switch-other />
      <table-list />
    </div>
  </div>
</template>
<script>
import SwitchOther from './components/SwitchOther'
import TableList from './components/TableList'
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  components: {
  //  SystemEdit,
    SwitchOther,
    TableList
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      systemOption: {
        placeholder: '',
        modules: {
          toolbar: [ ]
        }
      },
      wechatOption: {
        placeholder: '',
        modules: {
          toolbar: [
            [{ 'color': [] }]
          ]
        }
      },
      emailOption: {
        placeholder: this.$t('message["74"]'),
        modules: {
          toolbar: [
            [{ 'font': [] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'color': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'align': [] }]
          ]
        }
      }
    }
  },
  computed: {
    ...mapState('config/notice', ['tabName', 'fetching', 'expands']),
    ...mapGetters(['currentData'])
  },
  mounted () {
  },
  methods: {
    ...mapMutations('config/notice', ['changeExpands']),
    // getMembers,
    // getType,
    editMsg (row, index, e, s) {
      // this.expands = row.id
      this.changeExpands(row.id)
      // document.getElementsByClassName('el-table__body')[0].style.display = 'none'
    },
    resetForm (row) {
      this.expands = ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .receive-p-list {
    span {
      height: 24px;
      line-height: 24px;
      background: #eceff1;
      padding: 0 10px;
      border-radius: 4px;
      display: inline-block;
      margin-right: 4px;
      margin-bottom: 5px;
    }
  }

  .icon-tip-notice-normal-gr {
    color: #b3b3b3;
  }

  .audit-tip-box {
    width: 240px;
    line-height: 20px;
  }

  .audit-hover {
    width: 240px;
    line-height: 20px;
  }

  .op-tool-box {
    position: relative;
  }

  .template-con, .template-tit {
    height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 260px;
  }

  .template-con2 {
    width: 360px;
  }

  .template-tit {
    width: 155px;
  }
</style>
